import React from 'react'
import { List, Datagrid, TextField, Filter, TextInput, EditButton, DeleteButton } from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  colorBox: {
    width: 24,
    height: 24,
    borderRadius: 4,
    display: 'inline-block',
    marginRight: theme.spacing(1),
    border: '1px solid #ccc',
  },
}))

const ColorField = ({ record, source }) => {
  const classes = useStyles()
  if (!record[source]) return null
  return (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      <span className={classes.colorBox} style={{ backgroundColor: record[source] }} />
      <span>{record[source]}</span>
    </span>
  )
}

const TagTypeFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
)

const TagTypeList = (props) => (
  <List hasCreate filters={<TagTypeFilter />} {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="description" />
      <ColorField source="color" label="Color" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
)

export default TagTypeList

